import { apiConfig, USE_IDENTITY_SERVER } from '../_config'
import UserHelper from '../_helpers/UserHelper';

const redirectSignIn = (tenant) => {
    const manager = UserHelper.getUserManager();

    // Prevent loop: if we're already on /callback or currently have OIDC params, don't start another redirect
    const qs = window.location.search;
    const isAuthResponse = qs.includes('code=') || qs.includes('id_token=');
    const hasAuthError = qs.includes('error=');
    const storedError = (() => { try { return sessionStorage.getItem('auth_last_error'); } catch(e){ return null; } })();
    if (storedError && window.location.pathname !== '/auth-error') {
        console.warn('[identityService] Stored auth error present; routing to /auth-error instead of redirecting');
        try { window.history.replaceState({}, '', '/auth-error'); } catch(e) {}
        return;
    }
    if (hasAuthError) {
        // Don't keep redirecting if we have an auth error (e.g. AADSTS500206)
        console.warn('[identityService] Auth error detected in query string; suppressing signinRedirect to avoid loop');
        return;
    }
    if (window.location.pathname === '/callback' && isAuthResponse) {
        console.log('[identityService] Suppressing extra signinRedirect while processing callback');
        return;
    }

    if (tenant) {
        const args = (USE_IDENTITY_SERVER ? { acr_values: 'tenant:' + tenant + ' apiurl:' + apiConfig.baseApiUrl } : {});
        manager.signinRedirect(args);
    } else {
        manager.signinRedirect();
    }
}

export const identityService = {
    redirectSignIn
}